<template>
    <Head title="My Best Cards" />
    <div class="px-4 md:px-8">
        <BestCardsByCategoryIndex
            :best-cards="bestCards"
            :wallet-users="walletUsers"
            :available-categories="availableCategories"
            :selected-user-id="selectedUserId"
            :wallet-card-count="walletCardCount"
            :filtered-card-count="filteredCardCount"
            :has-cards-for-user="hasCardsForUser"
            :selected-user-name="selectedUserName"
            :is-subscribed="isSubscribed"
        />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import BestCardsByCategoryIndex from '@/components/wallet/best-cards-by-category/index.vue';
import { useSubscription } from '@/composables/useSubscription.js';

const { isSubscribed } = useSubscription();

defineProps({
    bestCards: {
        type: Array,
        default: () => [],
    },
    walletUsers: {
        type: Array,
        default: () => [],
    },
    availableCategories: {
        type: Array,
        default: () => [],
    },
    selectedUserId: {
        type: [Number, String],
        default: null,
    },
    walletCardCount: {
        type: Number,
        default: 0,
    },
    filteredCardCount: {
        type: Number,
        default: 0,
    },
    hasCardsForUser: {
        type: Boolean,
        default: false,
    },
    selectedUserName: {
        type: String,
        default: null,
    },
});
</script>
